import { CartModificationPayload } from '@cart/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CustomCartState, StateWithCustomCart } from '../cart-state';
import { getCustomCartState } from './feature.selector';

export const getCompareCartValue: MemoizedSelector<StateWithCustomCart, CartModificationPayload> = createSelector(
  getCustomCartState,
  (state: CustomCartState) => StateUtils.loaderValueSelector(state.cartDiff),
);

export const getNewBaseSiteId: MemoizedSelector<StateWithCustomCart, string> = createSelector(
  getCustomCartState,
  (state: CustomCartState) => StateUtils.loaderValueSelector(state.cartDiff).newBaseSiteId,
);
